export default "__VITE_ASSET__CxMIBWry__"